import * as qs from 'app/lib/helperjs';

const ACTIVE = 'visible';

const MAIN_NAV_SELECTOR = '.js-main-nav';
const OPEN_NAV_SELECTOR = '.js-nav-open';
const CLOSE_NAV_SELECTOR = '.js-nav-exit';
const NOTIFICATION_BAR_SELECTOR = '.notificationBar';

const OVERLAY_CLASS = 'main-nav-overlay';

export const MobileHeaderNav = () => {
    const navigation = qs.querySelector(MAIN_NAV_SELECTOR);
    const openButton = qs.querySelector(OPEN_NAV_SELECTOR);
    const closeButton = qs.querySelector(CLOSE_NAV_SELECTOR);
    const notificationBar = qs.querySelector(NOTIFICATION_BAR_SELECTOR);

    if (!navigation || !openButton || !closeButton) {
        return;
    }

    const overlay = qs.createElement('div', {
        class: OVERLAY_CLASS,
        onClick() {
            closeButton.click();
        },
    });

    openButton.addEventListener('click', () => {
        qs.addClass(navigation, ACTIVE);
        document.body.prepend(overlay);
        navigation.style.top = (0 - notificationBar.offsetHeight) + "px";
    });
    closeButton.addEventListener('click', () => {
        qs.removeClass(navigation, ACTIVE);
        qs.removeElement(overlay);
    });
};
